<style scoped>
    @import url("../../../styles/smartControl/criarFase.scss");
</style>

<template>
    <div class="box_criarFase">

        <div class="macro_el">
            <!--<div class="tit ml-2">Edição</div>-->

            <div class="painelSearch">

                <div class="searchBar mt-1 mb-1">

                    <v-btn 
                    height="60px"
                    class="btnOpenForm_int mb-2"
                    density="comfortable"
                    :style="{'color':'rgb(31,122,177)'}"
                    block
                    @click="flagMsgShow = true"
                    >
                    <!-- :disabled="!flagBtnUp" -->
                        <v-icon v-if="!flagMsgShow" class="mr-1" size="16">mdi-plus</v-icon>
                        <span v-if="!flagMsgShow" class="txt_btn_irrig">NOVA FASE</span>

                        <div class="mb-1" :style="{'font-size':'0.7rem'}" v-if="flagMsgShow">
                            <span>A criação de nova fase estará disponível em breve.</span>
                        </div>
                    </v-btn>

                </div>
            </div>

        </div>

    </div>
</template>

<script>

export default {

    props:['agent_unit'],

    data() {
        return {

            // criação
            flagForm:false, // form inicia desabilitado

            // msg
            flagMsgShow:false,
        }
    },

    methods:{

        trocarAlvoLocal(alvoSelectedFromFront) {
            //console.log('alvoLocal: ',alvoSelectedFromFront)
            this.alvoSelected = alvoSelectedFromFront // up local exib

            // -- SE houve alteração então req up.
            //console.log('[alvoFC][trocaralvoLocal] this.alvoInit: ',this.alvoInit)
            //console.log('[alvoFC][trocaralvoLocal] alvoSelectedFromFront: ',alvoSelectedFromFront)
            if (this.alvoInit != alvoSelectedFromFront) { this.flagBtnUp = true }
            else { this.flagBtnUp = false }
        },

        callFather() {
            // -- componente pai trata a requisição de update.
            // --- pai espera o doc ~estrutura~ completo.
            this.estruturaLocal['target_fc'] = this.alvoSelected // string
            //console.log('[alvoFC] estruturaLocal: ',this.estruturaLocal)
            this.$emit('fromChildUp', this.estruturaLocal) // dict input_last_info
        },
    },

    created() {
        //window.scrollTo(0,0)
    }
}
</script>